export default {
  fontColor: {
    colors: [
      {
        color: '#000',
        label: '黑色',
      },
      {
        color: '#555',
        label: '昏灰',
      },
      {
        color: '#999',
        label: '灰色',
      },
      {
        color: '#ccc',
        label: '亮灰',
      },
      {
        color: '#fff',
        label: '白色',
        hasBorder: true,
      },
      {
        color: '#df3c2f',
        label: '红色',
      },
      {
        color: '#44acb6',
        label: '绿松色',
      },
      {
        color: '#51b52f',
        label: '绿色',
      },
      {
        color: '#f5941d',
        label: '橙色',
      },
      {
        color: '#5c6bc0',
        label: '蓝色',
      },
      {
        color: '#f06292',
        label: '玫红',
      },
      {
        color: '#65d0d7',
        label: '水蓝',
      },
      {
        color: '#9ccc65',
        label: '草绿',
      },
      {
        color: '#8d6e63',
        label: '褐色',
      },
      {
        color: '#9575cd',
        label: '紫色',
      },
      {
        color: '#ffab91',
        label: '粉色',
      },
      {
        color: '#b7ebed',
        label: '青色',
      },
      {
        color: '#dce775',
        label: '绿黄',
      },
      {
        color: '#fdd835',
        label: '黄色',
      },
      {
        color: '#ce93d8',
        label: '兰紫',
      },
    ],
    columns: 5,
  },
  helpButton: 'https://tower.im/help/articles/334',
};
